<header class="main-header">

  <!-- ==================== DESKTOP HEADER ==================== -->

  <div class="desktop-header">

    <!-- LOGO -->
     <div class="logo">
<img src="../../../../assets/images/logoo.png" />
  
</div>

    <!-- DESKTOP SEARCH -->
    <form
      class="desktop-search"
      (submit)="$event.preventDefault(); searchProducts()">

      <mat-icon>
        search
      </mat-icon>

      <input
        type="search"
        [value]="searchTerm()"
        (input)="onSearchInput($any($event.target).value)"
        (focus)="showSearchSuggestions.set(searchTerm().trim().length >= 2)"
        [placeholder]="'HEADER.SEARCH_PRODUCTS' | translate"
        autocomplete="off">


      @if (searchTerm()) {

        <button
          type="button"
          class="search-clear-button"
          (click)="clearSearch()">

          <mat-icon>
            close
          </mat-icon>

        </button>

      }


      <button
        type="submit"
        class="search-submit-button"
        [attr.aria-label]="'HEADER.SEARCH_PRODUCTS' | translate">

        <mat-icon>
          search
        </mat-icon>

      </button>


      <!-- ==================== SEARCH AUTOCOMPLETE ==================== -->

      @if (
        showSearchSuggestions() &&
        searchTerm().trim().length >= 2
      ) {

        <div
          class="search-suggestions"
          (click)="$event.stopPropagation()">


          <!-- ==================== PRODUCTS ==================== -->

          @if (searchProductsResults().length > 0) {

            <div class="search-section">

              <div class="search-section-title">

                <mat-icon>
                  inventory_2
                </mat-icon>

                <span>
                  {{ 'HEADER.PRODUCTS' | translate }}
                </span>

              </div>


              @for (
                product of searchProductsResults();
                track product.id
              ) {

                <button
                  type="button"
                  class="search-suggestion-item"
                  (click)="selectSearchProduct(product)">

                  <span class="suggestion-icon">

                    <img width="90%"  height="90%" 
                     [src]="getImageUrl(product.imageUrl)"
                      loading="lazy"
                     />
                   

                  </span>


                  <span class="suggestion-content">

                    <span class="suggestion-name">

                      {{
                        languageService.isArabic()
                          ? (
                              product.nameAr.trim()
                                ? product.nameAr
                                : product.nameEn
                            )
                          : (
                              product.nameEn.trim()
                                ? product.nameEn
                                : product.nameAr
                            )
                      }}

                    </span>


                    <span class="suggestion-subtitle">

                      {{ 'HEADER.PRODUCTS' | translate }}

                    </span>

                  </span>

                </button>

              }

            </div>

          }


          <!-- ==================== BRANDS ==================== -->

          @if (searchBrandResults().length > 0) {

            <div class="search-section">

              <div class="search-section-title">

                <mat-icon>
                  sell
                </mat-icon>

                <span>
                  {{ 'HEADER.BRANDS' | translate }}
                </span>

              </div>


              @for (
                brand of searchBrandResults();
                track brand.id
              ) {

                <button
                  type="button"
                  class="search-suggestion-item"
                  (click)="selectBrand(brand.id)">

                  <span class="suggestion-icon">

                    <img  width="90%"  height="90%" 
                     [src]="getImageUrl(brand.imageUrl)"
                      loading="lazy"/>
                    

                  </span>


                  <span class="suggestion-content">

                    <span class="suggestion-name">

                      {{ getBrandName(brand) }}

                    </span>


                    <span class="suggestion-subtitle">

                      {{ 'HEADER.BRANDS' | translate }}

                    </span>

                  </span>

                </button>

              }

            </div>

          }


          <!-- ==================== LOADING ==================== -->

          @if (
            isSearching() &&
            searchProductsResults().length === 0
          ) {

            <div class="search-loading">

              <mat-icon class="loading-icon">
                sync
              </mat-icon>

              <span>
                {{ 'COMMON.LOADING' | translate }}
              </span>

            </div>

          }


          <!-- ==================== NO RESULTS ==================== -->

          @if (
            !isSearching() &&
            searchProductsResults().length === 0 &&
            searchBrandResults().length === 0
          ) {

            <div class="search-no-results">

              <mat-icon>
                search_off
              </mat-icon>

            

            </div>

          }

        </div>

      }

    </form>


    <!-- DESKTOP NAVIGATION -->
    <div class="headSection">

      <nav class="desktop-nav">

        <!-- HOME -->
        <a
          routerLink="/"
          class="nav-link"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }">

          {{ 'HEADER.HOME' | translate }}

        </a>


        <!-- PRODUCTS -->
        <a
          routerLink="/products"
          class="nav-link"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }">

          {{ 'HEADER.PRODUCTS' | translate }}

        </a>


        <!-- OFFERS -->
        <button
          type="button"
          class="nav-link offers-link"
          (click)="selectOffers()">

          <mat-icon>
            local_offer
          </mat-icon>

          <span>
            {{ 'HEADER.OFFERS' | translate }}
          </span>

          <span class="desktop-offer-badge">
            {{ 'HEADER.SALE' | translate }}
          </span>

        </button>


        <!-- CATEGORIES -->
        <div
          class="nav-dropdown"
          (mouseenter)="openCategoryMenu()"
          (mouseleave)="closeCategoryMenu()">

          <button
            type="button"
            class="nav-link dropdown-trigger"
            (click)="toggleCategoryMenu()">

            <span>
              {{ 'HEADER.CATEGORIES' | translate }}
            </span>

            <mat-icon>
              {{
                categoryMenuOpen()
                  ? 'keyboard_arrow_up'
                  : 'keyboard_arrow_down'
              }}
            </mat-icon>

          </button>


          @if (categoryMenuOpen()) {

            <div
              class="dropdown-menu category-dropdown"
              (click)="$event.stopPropagation()">

              <div class="dropdown-header">

                <div>

                  <span class="dropdown-title">
                    {{ 'HEADER.CATEGORIES' | translate }}
                  </span>

                  <small>
                    {{ 'HEADER.Explore_our_collection' | translate }}
                  </small>

                </div>

                <mat-icon>
                  category
                </mat-icon>

              </div>


              @if (isLoadingCategories()) {

                <div class="menu-loading">

                  <mat-icon class="loading-icon">
                    sync
                  </mat-icon>

                  <span>
                    {{ 'COMMON.LOADING' | translate }}
                  </span>

                </div>

              }


              @if (categoryError()) {

                <div class="menu-error">
                  {{ categoryError() }}
                </div>

              }


              @if (
                !isLoadingCategories() &&
                !categoryError()
              ) {

                <div class="category-list">

                  @for (
                    category of categories();
                    track category.id
                  ) {

                    <div class="category-item">

                      <button
                        type="button"
                        class="category-button"
                        (click)="toggleCategory(category.id)">

                        <span class="category-name">
                          {{ getCategoryName(category) }}
                        </span>

                        @if (
                          (category.subCategories?.length ?? 0) > 0
                        ) {

                          <mat-icon>
                            {{
                              expandedCategoryId() === category.id
                                ? 'keyboard_arrow_up'
                                : 'keyboard_arrow_down'
                            }}
                          </mat-icon>

                        }

                      </button>


                      @if (
                        expandedCategoryId() === category.id &&
                        (category.subCategories?.length ?? 0) > 0
                      ) {

                        <div class="subcategory-list">

                          @for (
                            subCategory of category.subCategories;
                            track subCategory.id
                          ) {

                            <button
                              type="button"
                              class="subcategory-button"
                              (click)="selectSubCategory(subCategory.id)">

                              <span class="subcategory-dot">
                                •
                              </span>

                              <span>
                                {{ getSubCategoryName(subCategory) }}
                              </span>

                            </button>

                          }

                        </div>

                      }

                    </div>

                  }


                  @if (categories().length === 0) {

                    <div class="menu-empty">
                      {{ 'CATEGORY.No_categories_available' | translate }}
                    </div>

                  }

                </div>

              }

            </div>

          }

        </div>


        <!-- BRANDS -->
        <div
          class="navbarnd-dropdown"
          (mouseenter)="openBrandMenu()"
          (mouseleave)="closeBrandMenu()">

          <button
            type="button"
            class="nav-link dropdown-trigger"
            (click)="toggleBrandMenu()">

            <span>
              {{ 'HEADER.BRANDS' | translate }}
            </span>

            <mat-icon>
              {{
                brandMenuOpen()
                  ? 'keyboard_arrow_up'
                  : 'keyboard_arrow_down'
              }}
            </mat-icon>

          </button>


          @if (brandMenuOpen()) {

            <div
              class="dropdown-menu brand-dropdown"
              (click)="$event.stopPropagation()">

              <div class="dropdown-header">

                <div>

                  <span class="dropdown-title">
                    {{ 'HEADER.BRANDS' | translate }}
                  </span>

                  <small>
                    {{ 'HEADER.Shop_your_favorite_brands' | translate }}
                  </small>

                </div>

                <mat-icon>
                  sell
                </mat-icon>

              </div>


              @if (isLoadingBrands()) {

                <div class="menu-loading">

                  <mat-icon class="loading-icon">
                    sync
                  </mat-icon>

                  <span>
                    {{ 'COMMON.LOADING' | translate }}
                  </span>

                </div>

              }


              @if (brandError()) {

                <div class="menu-error">
                  {{ brandError() }}
                </div>

              }


              @if (
                !isLoadingBrands() &&
                !brandError()
              ) {

                <div class="brand-list">

                  @for (
                    brand of brands();
                    track brand.id
                  ) {

                    <button
                      type="button"
                      class="brand-button"
                      (click)="selectBrand(brand.id)">

                      <span>
                        {{ getBrandName(brand) }}
                      </span>

                    </button>

                  }


                  @if (brands().length === 0) {

                    <div class="menu-empty">
                      {{ 'BRAND.No_brands_available' | translate }}
                    </div>

                  }

                </div>

              }

            </div>

          }

        </div>

      </nav>


      <!-- CART -->
      <div class="header-actions">

        <a
          routerLink="/cart"
          class="cart-button">

          <mat-icon>
            shopping_bag
          </mat-icon>

          <span class="cart-count">
            {{ cartCount() }}
          </span>

        </a>

      </div>


      <!-- LANGUAGE -->
      <div class="header-actions">

        <button
          type="button"
          class="language-switcher"
          (click)="languageService.toggleLanguage()">

          <mat-icon>
            language
          </mat-icon>

          <!-- <span>
            {{
              languageService.currentLanguage() === 'en'
                ? ('HEADER.ARABIC' | translate)
                : ('HEADER.ENGLISH' | translate)
            }}
          </span> -->

        </button>

      </div>

    </div>

  </div>


  <!-- ==================== MOBILE HEADER ==================== -->

  <div class="mobile-header">

  <button
      type="button"
      class="menu-button"
      (click)="openMobileMenu()">

      <mat-icon>
        menu
      </mat-icon>

    </button>
 

    <!-- LOGO -->
    <div class="logoMobile">
<img src="../../../../assets/images/logoo.png" />
 </div>
<div class="mobileHeader">
    <!-- MOBILE SEARCH -->
    <button
      type="button"
      class="mobile-search-button"
      (click)="toggleMobileSearch()">

      <mat-icon>
        {{ mobileSearchOpen() ? 'close' : 'search' }}
      </mat-icon>

    </button>


    <!-- CART -->
    <a
      routerLink="/cart"
      class="cart-button">

      <mat-icon>
        shopping_bag
      </mat-icon>

      <span class="cart-count">
        {{ cartCount() }}
      </span>

    </a>


    <!-- LANGUAGE -->
    <button
      type="button"
      class="language-switcher"
      (click)="languageService.toggleLanguage()">

      <mat-icon>
        language
      </mat-icon>

    <!--   <span>
        {{
          languageService.currentLanguage() === 'en'
            ? ('HEADER.ARABIC' | translate)
            : ('HEADER.ENGLISH' | translate)
        }}
      </span> -->

    </button>
</div>
  </div>


  <!-- ==================== MOBILE SEARCH ==================== -->

  @if (mobileSearchOpen()) {

    <form
      class="mobile-search"
      (submit)="$event.preventDefault(); searchProducts()">

      <div class="mobile-search-box">

        <mat-icon>
          search
        </mat-icon>

        <input
          type="search"
          [value]="searchTerm()"
          (input)="onSearchInput($any($event.target).value)"
          (focus)="showSearchSuggestions.set(searchTerm().trim().length >= 2)"
          [placeholder]="'HEADER.SEARCH_PRODUCTS' | translate"
          autocomplete="off">


        @if (searchTerm()) {

          <button
            type="button"
            class="search-clear-button"
            (click)="clearSearch()">

            <mat-icon>
              close
            </mat-icon>

          </button>

        }


        <button
          type="submit"
          class="search-submit-button"
          [attr.aria-label]="'HEADER.SEARCH_PRODUCTS' | translate">

          <mat-icon>
            search
          </mat-icon>

        </button>

      </div>


      <!-- ==================== MOBILE SEARCH AUTOCOMPLETE ==================== -->

      @if (
        showSearchSuggestions() &&
        searchTerm().trim().length >= 2
      ) {

        <div
          class="search-suggestions mobile-suggestions"
          (click)="$event.stopPropagation()">


          <!-- ==================== PRODUCTS ==================== -->

          @if (searchProductsResults().length > 0) {

            <div class="search-section">

              <div class="search-section-title">

                <mat-icon>
                  inventory_2
                </mat-icon>

                <span>
                  {{ 'HEADER.PRODUCTS' | translate }}
                </span>

              </div>


              @for (
                product of searchProductsResults();
                track product.id
              ) {

                <button
                  type="button"
                  class="search-suggestion-item"
                  (click)="selectSearchProduct(product)">

                  <span class="suggestion-icon">

                    <img width="90%"  height="90%" 
                     [src]="getImageUrl(product.imageUrl)"
                      loading="lazy"
                     />

                  </span>


                  <span class="suggestion-content">

                    <span class="suggestion-name">

                      {{
                        languageService.isArabic()
                          ? (
                              product.nameAr.trim()
                                ? product.nameAr
                                : product.nameEn
                            )
                          : (
                              product.nameEn.trim()
                                ? product.nameEn
                                : product.nameAr
                            )
                      }}

                    </span>


                    <span class="suggestion-subtitle">

                      {{ 'HEADER.PRODUCTS' | translate }}

                    </span>

                  </span>

                </button>

              }

            </div>

          }


          <!-- ==================== BRANDS ==================== -->

          @if (searchBrandResults().length > 0) {

            <div class="search-section">

              <div class="search-section-title">

                <mat-icon>
                  sell
                </mat-icon>

                <span>
                  {{ 'HEADER.BRANDS' | translate }}
                </span>

              </div>


              @for (
                brand of searchBrandResults();
                track brand.id
              ) {

                <button
                  type="button"
                  class="search-suggestion-item"
                  (click)="selectBrand(brand.id)">

                  <span class="suggestion-icon">

                     <img  width="90%"  height="90%" 
                     [src]="getImageUrl(brand.imageUrl)"
                      loading="lazy"/>

                  </span>


                  <span class="suggestion-content">

                    <span class="suggestion-name">

                      {{ getBrandName(brand) }}

                    </span>


                    <span class="suggestion-subtitle">

                      {{ 'HEADER.BRANDS' | translate }}

                    </span>

                  </span>

                </button>

              }

            </div>

          }


          <!-- ==================== LOADING ==================== -->

          @if (
            isSearching() &&
            searchProductsResults().length === 0
          ) {

            <div class="search-loading">

              <mat-icon class="loading-icon">
                sync
              </mat-icon>

              <span>
                {{ 'COMMON.LOADING' | translate }}
              </span>

            </div>

          }


          <!-- ==================== NO RESULTS ==================== -->

          @if (
            !isSearching() &&
            searchProductsResults().length === 0 &&
            searchBrandResults().length === 0
          ) {

            <div class="search-no-results">

              <mat-icon>
                search_off
              </mat-icon>

              <span>
                {{ 'HEADER.NO_RESULTS' | translate }}
              </span>

            </div>

          }

        </div>

      }

    </form>

  }

</header>


<!-- ==================== MOBILE SIDEBAR ==================== -->

@if (mobileMenuOpen()) {

  <!-- OVERLAY -->
  <div
    class="sidebar-overlay"
    (click)="closeMobileMenu()">
  </div>


  <!-- SIDEBAR -->
  <aside class="mobile-sidebar">

    <!-- SIDEBAR HEADER -->
    <div class="sidebar-header">

        <div class="logoMobile">
<img src="../../../../assets/images/logoo.png" />
 </div>

      <button
        type="button"
        class="close-button"
        (click)="closeMobileMenu()">

        <mat-icon>
          close
        </mat-icon>

      </button>

    </div>


    <!-- MOBILE NAVIGATION -->
    <nav class="mobile-nav">

      <!-- HOME -->
      <a
        routerLink="/"
        class="mobile-nav-link"
        (click)="closeMobileMenu()">

        <div class="mobile-link-content">

          <mat-icon>
            home
          </mat-icon>

          <span>
            {{ 'HEADER.HOME' | translate }}
          </span>

        </div>

      </a>


      <!-- OFFERS -->
      <button
        type="button"
        class="mobile-nav-link mobile-offers"
        (click)="selectOffers()">

        <div class="mobile-link-content">

          <mat-icon>
            local_offer
          </mat-icon>

          <span>
            {{ 'HEADER.OFFERS' | translate }}
          </span>

        </div>

        <span class="mobile-sale-badge">
          {{ 'HEADER.SALE' | translate }}
        </span>

      </button>


      <!-- CATEGORIES -->
      <button
        type="button"
        class="mobile-nav-link"
        (click)="toggleCategoryMenu()">

        <div class="mobile-link-content">

          <mat-icon>
            category
          </mat-icon>

          <span>
            {{ 'HEADER.CATEGORIES' | translate }}
          </span>

        </div>

        <mat-icon>
          {{
            categoryMenuOpen()
              ? 'keyboard_arrow_up'
              : 'keyboard_arrow_down'
          }}
        </mat-icon>

      </button>


      <!-- MOBILE CATEGORIES -->
      @if (categoryMenuOpen()) {

        <div class="mobile-dropdown">

          @if (isLoadingCategories()) {

            <div class="mobile-loading">

              <mat-icon class="loading-icon">
                sync
              </mat-icon>

              <span>
                {{ 'COMMON.LOADING' | translate }}
              </span>

            </div>

          }


          @if (categoryError()) {

            <div class="mobile-error">
              {{ categoryError() }}
            </div>

          }


          @if (
            !isLoadingCategories() &&
            !categoryError()
          ) {

            @for (
              category of categories();
              track category.id
            ) {

              <div class="mobile-category">

                <button
                  type="button"
                  class="mobile-category-button"
                  (click)="toggleCategory(category.id)">

                  <span>
                    {{ getCategoryName(category) }}
                  </span>

                  @if (
                    (category.subCategories?.length ?? 0) > 0
                  ) {

                    <mat-icon>
                      {{
                        expandedCategoryId() === category.id
                          ? 'remove'
                          : 'add'
                      }}
                    </mat-icon>

                  }

                </button>


                <!-- SUBCATEGORIES -->
                @if (
                  expandedCategoryId() === category.id &&
                  (category.subCategories?.length ?? 0) > 0
                ) {

                  <div class="mobile-subcategories">

                    @for (
                      subCategory of category.subCategories;
                      track subCategory.id
                    ) {

                      <button
                        type="button"
                        class="mobile-subcategory"
                        (click)="selectSubCategory(subCategory.id)">

                        <span>
                          •
                        </span>

                        <span>
                          {{ getSubCategoryName(subCategory) }}
                        </span>

                      </button>

                    }

                  </div>

                }

              </div>

            }

          }

        </div>

      }


      <!-- BRANDS -->
      <button
        type="button"
        class="mobile-nav-link"
        (click)="toggleBrandMenu()">

        <div class="mobile-link-content">

          <mat-icon>
            sell
          </mat-icon>

          <span>
            {{ 'HEADER.BRANDS' | translate }}
          </span>

        </div>

        <mat-icon>
          {{
            brandMenuOpen()
              ? 'keyboard_arrow_up'
              : 'keyboard_arrow_down'
          }}
        </mat-icon>

      </button>


      <!-- MOBILE BRANDS -->
      @if (brandMenuOpen()) {

        <div class="mobile-dropdown">

          @if (isLoadingBrands()) {

            <div class="mobile-loading">

              <mat-icon class="loading-icon">
                sync
              </mat-icon>

              <span>
                {{ 'COMMON.LOADING' | translate }}
              </span>

            </div>

          }


          @if (brandError()) {

            <div class="mobile-error">
              {{ brandError() }}
            </div>

          }


          @if (
            !isLoadingBrands() &&
            !brandError()
          ) {

            @for (
              brand of brands();
              track brand.id
            ) {

              <button
                type="button"
                class="mobile-brand"
                (click)="selectBrand(brand.id)">

                <span>
                  {{ getBrandName(brand) }}
                </span>

              </button>

            }


            @if (brands().length === 0) {

              <div class="menu-empty">
                {{ 'BRAND.No_brands_available' | translate }}
              </div>

            }

          }

        </div>

      }


      <!-- CART -->
      <a
        routerLink="/cart"
        class="mobile-nav-link"
        (click)="closeMobileMenu()">

        <div class="mobile-link-content">

          <mat-icon>
            shopping_bag
          </mat-icon>

          <span>
            {{ 'HEADER.CART' | translate }}
          </span>

        </div>

        <span class="mobile-cart-badge">
          {{ cartCount() }}
        </span>

      </a>

    </nav>

  </aside>

}